import React, { useEffect, useState } from "react";
import { TabPanel, TabView } from "primereact/tabview";
import {
  getCustomerAddress,
  getCustomerContact,
} from "../../../../../services/sales/customerService";
import {
  FormDateField,
  FormSelectField,
  FormTextField,
} from "../../../../../partials/content/Forms/FormField";
import { getPredefinedTOCs } from "../../../../../services/commons";
import { Card, Badge } from "react-bootstrap";
import { useFormikContext } from "formik";
import { Editor } from "primereact/editor";
import InvoiceAddress from "./invoiceAddress";
import InvoiceContact from "./invoiceContact";
import InvoiceTOC from "./invoiceTOC";
import DialogLayout from "../../../../../partials/content/DialogLayout";
import { DialogActions } from "@material-ui/core";
import { getSalesOrderItems } from "../../../../../services/sales/salesOrderService";
import { getDelivery } from "../../../../../services/inventory/deliveryService";
import { amountByPercent } from "../../../../../utils/utils";
import SearchInvoiceDocRef from "../searchInvoiceDocRef";
import SearchGlAccount from "../../../setup/finance/searchGlAccount";
import { Checkbox } from "primereact/checkbox";
import { getSoDeliveryDetail } from "../../../../../services/sales/salesDeliveryService";

function InvoiceHeader(props) {
  const [openSearchCashAccount, setOpenSearchCashAccount] = useState(false);
  const [openSearchDocRef, setOpenSearchDocRef] = useState(false);
  const [customerAddresses, setCustomerAddresses] = useState([]);
  const [customerContacts, setCustomerContacts] = useState([]);
  const [invoiceTOCs, setInvoiceTOCs] = useState([]);
  const [customerAddressDefault, setCustomerAddressDefault] = useState(false);
  const [customerContactDefault, setCustomerContactDefault] = useState(false);
  const [customerTOCDefault, setCustomerTOCDefault] = useState(false);
  const { values, setFieldValue } = useFormikContext();
  useEffect(() => {
    getInvoiceTOCData("INVO");
  }, [values.customerID]);
  return (
    <React.Fragment>
      <div className="tabview mb-3">
        <div className="card">
          <TabView renderActiveOnly={false} className="tabview" scrollable>
            <TabPanel header="A/R Invoice Main" rightIcon="fas fa-th-large">
              <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12">
                  <Card>
                    <Card.Header>
                      <i className="fas fa-window-maximize"></i>
                      <span>
                        <strong>Account Receivable Invoice Header</strong>
                      </span>
                      {values.invoiceCode !== "" ? (
                        <React.Fragment>
                          <Badge
                            className="float-right ml-1"
                            variant={
                              values.paymentStatus === 1
                                ? "danger"
                                : values.paymentStatus === 2
                                ? "warning"
                                : values.paymentStatus === 3
                                ? "success"
                                : null
                            }
                          >
                            {values.paymentStatus !== 0
                              ? "Payment " + values.paymentStatusDesc
                              : null}
                          </Badge>
                          <Badge
                            className="float-right ml-1"
                            variant={
                              values.giStatus === 1
                                ? "danger"
                                : values.giStatus === 2
                                ? "warning"
                                : values.giStatus === 3
                                ? "success"
                                : null
                            }
                          >
                            {values.giStatus !== 0
                              ? "Goods " + values.giStatusDesc
                              : null}
                          </Badge>
                          <Badge
                            className="float-right ml-1"
                            variant={
                              values.invoiceType === "1"
                                ? "primary"
                                : values.invoiceType === "2"
                                ? "info"
                                : null
                            }
                          >
                            {values.invoiceType === "1"
                              ? "Normal A/R Invoice"
                              : values.invoiceType === "2"
                              ? "Recurring A/R Invoice"
                              : null}
                          </Badge>
                        </React.Fragment>
                      ) : null}
                    </Card.Header>
                    <Card.Body>
                      <div className="row">
                        <div className="col-sm-6 col-md-6 col-lg-6">
                          {values.invoiceCode !== "" ? (
                            <FormTextField
                              label="A/R Invoice ID"
                              name="invoiceCode"
                              readonly
                            />
                          ) : null}
                          <div className="row">
                            <div className="col-sm-12 col-md-12 col-lg-6">
                              <FormTextField
                                label="Document Reference"
                                name="docRefDesc"
                                searchButton={values.ID > 0 ? false : true}
                                readonly
                                onSearchClick={() => {
                                  setOpenSearchDocRef(true);
                                }}
                              />
                            </div>
                            <div className="col-sm-12 col-md-12 col-lg-6">
                              {values.docRef === "1" ? (
                                <FormTextField
                                  label="Sales Order ID"
                                  name="salesOrderCode"
                                  readonly
                                />
                              ) : (
                                <FormTextField
                                  label="Delivery ID"
                                  name="deliveryID"
                                  readonly
                                />
                              )}
                            </div>
                          </div>
                          <FormTextField
                            label="Customer Name"
                            name="customerName"
                            readonly
                          />
                          <div className="row">
                            <div className="col-sm-12 col-md-12 col-lg-6">
                              <FormTextField
                                label="Currency"
                                name="currencyCode"
                                readonly
                              />
                            </div>
                            <div className="col-sm-12 col-md-12 col-lg-6">
                              <FormTextField
                                label="Exchange Rate To Base Currency"
                                name="exchangeRate"
                                currencyField
                                fullDecimals={true}
                                readonly
                              />
                            </div>
                          </div>
                          {values.docRef === "2" ? (
                            <FormTextField
                              label="Sales Order ID"
                              name="salesOrderCode"
                              readonly
                            />
                          ) : null}
                        </div>
                        <div className="col-sm-6 col-md-6 col-lg-6">
                          <FormTextField
                            label="Cash Account"
                            name="cashAccountName"
                            searchButton={values.ID > 0 ? false : true}
                            readonly
                            clearButton={values.ID > 0 ? false : true}
                            onSearchClick={() => {
                              setOpenSearchCashAccount(true);
                            }}
                            clearFields={[
                              { field: "cashAccountID", clearValue: 0 },
                              { field: "cashAccountName", clearValue: "" },
                            ]}
                          />
                          {values.invoiceType === "2" ? (
                            <React.Fragment>
                              <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-6">
                                  <FormDateField
                                    label="startDate"
                                    name="recStartDate"
                                  />
                                </div>
                                <div className="col-sm-12 col-md-12 col-lg-6">
                                  <FormDateField
                                    label="issueDate"
                                    name="recIssueDate"
                                  />
                                </div>
                              </div>
                              <FormDateField
                                label="deadlineDate"
                                name="recDeadlineDate"
                              />
                              <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-6">
                                  <FormTextField label="Every" name="number" />
                                </div>
                                <div className="col-sm-12 col-md-12 col-lg-6">
                                  <FormSelectField
                                    label="Period"
                                    name="periodType"
                                    options={[
                                      { value: "D", label: "Day" },
                                      { value: "W", label: "Week" },
                                      { value: "M", label: "Month" },
                                      { value: "Y", label: "Year" },
                                    ]}
                                  />
                                </div>
                              </div>
                            </React.Fragment>
                          ) : (
                            <React.Fragment>
                              <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-6">
                                  {values.ID > 0 ? (
                                    <FormDateField
                                      label="Invoice Date"
                                      name="invoiceDate"
                                      readonly
                                    />
                                  ) : (
                                    <FormDateField
                                      label="Invoice Date"
                                      name="invoiceDate"
                                    />
                                  )}
                                </div>
                                <div className="col-sm-12 col-md-12 col-lg-6">
                                  <FormDateField
                                    label="Deadline Date"
                                    name="deadlineDate"
                                  />
                                </div>
                              </div>
                            </React.Fragment>
                          )}
                          {values.deliveryID === 0 ? (
                            <div className="p-field-checkbox my-3">
                              <Checkbox
                                icon="pi pi-check-circle"
                                inputId="allServiceDelivered"
                                checked={values.servicesDel}
                                onChange={(e) => {
                                  if (values.ID === 0) {
                                    setFieldValue("servicesDel", e.checked);
                                  }
                                }}
                                readOnly={values.ID > 0 ? true : false}
                                disabled={values.ID > 0 ? true : false}
                              />
                              <label htmlFor="allServiceDelivered">
                                All Services Delivered
                              </label>
                            </div>
                          ) : null}
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </div>
              </div>
            </TabPanel>
            <TabPanel
              header={`Address & Contact`}
              rightIcon="fas fa-map-marked-alt"
            >
              <div className="row">
                <div className="col-sm-6 col-md-6 col-lg-6 mb-3 mb-md-0">
                  <InvoiceAddress
                    values={values}
                    addressProp="address"
                    customerAddresses={customerAddresses}
                    title="Billing"
                    setFieldValue={setFieldValue}
                    customerAddressDefault={customerAddressDefault}
                    handleCustomerAddressDefault={handleCustomerAddressDefault}
                  />
                </div>
                <div className="col-sm-6 col-md-6 col-lg-6">
                  <InvoiceContact
                    values={values}
                    customerContacts={customerContacts}
                    title="Billing"
                    setFieldValue={setFieldValue}
                    customerContactDefault={customerContactDefault}
                    handleCustomerContactDefault={handleCustomerContactDefault}
                  />
                </div>
              </div>
            </TabPanel>
            <TabPanel
              header={`Note, Terms & Conditions`}
              rightIcon="fas fa-sticky-note"
            >
              <div className="row mb-3">
                <div className="col-sm-12 col-md-12 col-lg-12">
                  <Card>
                    <Card.Header>
                      <i className="fas fa-sticky-note"></i>
                      <span>
                        <strong>Note</strong>
                      </span>
                    </Card.Header>
                    <Card.Body>
                      <Editor
                        style={{ height: "200px", width: "100%" }}
                        onTextChange={(e) => {
                          setFieldValue("note", e.htmlValue);
                        }}
                        value={values.note}
                        placeholder="Type your notes here..."
                      />
                    </Card.Body>
                  </Card>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12">
                  <InvoiceTOC
                    invoiceTOCs={invoiceTOCs}
                    customerTOCDefault={customerTOCDefault}
                    handleCustomerTOCDefault={handleCustomerTOCDefault}
                  />
                </div>
              </div>
            </TabPanel>
          </TabView>
        </div>
      </div>
      <DialogLayout
        open={openSearchDocRef}
        title="Search Document Reference"
        onCloseDialog={() => {
          setOpenSearchDocRef(false);
        }}
        minHeight={true}
      >
        <SearchInvoiceDocRef
          onSelectDocRef={(docRef = "1", document) => {
            if (docRef === "1") {
              const additionalCost = document.salesOrderAddCost;
              let invoiceAddCost = [];
              setFieldValue("docRef", docRef);
              setFieldValue("docRefDesc", "Sales Order");
              setFieldValue("salesOrderID", document.ID);
              setFieldValue("salesOrderCode", document.salesOrderCode);
              setFieldValue("deliveryID", 0);
              setFieldValue("customerID", document.customerID);
              setFieldValue("customerName", document.customer.customerName);
              setFieldValue("currencyID", document.currencyID);
              setFieldValue("currencyCode", document.currency.currencyCode);
              setFieldValue("unbilledPercent", document.unbilledPercent);
              setFieldValue("unbilledAmount", document.unbilledAmount);
              setFieldValue("exchangeRate", document.exchangeRate);
              getSalesOrderItems(document.ID, "0").then((response) => {
                const { data } = response.data;
                const salesOrderItems = data.salesOrderItems;
                let invoiceItem = [];
                salesOrderItems.map((item, index) => {
                  invoiceItem.push({
                    ID: 0,
                    salesOrderItemID: item.ID,
                    deliveryItemID: 0,
                    itemID: item.itemID,
                    itemType: item.itemType,
                    itemTypeName: item.itemTypeName,
                    itemCode: item.itemCode,
                    itemName: item.itemName,
                    varCode: item.varCode,
                    qty: item.qty,
                    uomID: item.uomID,
                    uomName: item.uom.uomName,
                    unitPrice: item.unitPrice,
                    taxPercent: item.taxPercent,
                    taxAmount: item.taxAmount,
                    discountPercent: item.discountPercent,
                    discountAmount: item.discountAmount,
                    totalPrice: item.totalPrice,
                    expenseAccountID: 0,
                    accountName: "",
                    unRegItem: false,
                    soItem: true,
                    deliveryItem: false,
                    deleteInd: false,
                  });
                });
                setFieldValue("invoiceItem", invoiceItem);
                setFieldValue("subTotal", document.subTotal);
                setFieldValue("discountPercent", document.discountPercent);
                setFieldValue("discountAmount", document.discountAmount);
                setFieldValue("taxPercent", document.taxPercent);
                setFieldValue("taxAmount", document.taxAmount);
                setFieldValue("taxName", document.taxName);
                setFieldValue("grandTotal", document.grandTotal);
                setFieldValue("billPercent", document.unbilledPercent);
                setFieldValue("billAmount", document.unbilledAmount);
              });
              additionalCost.map((item, index) => {
                if (item.invoiceID > 0) {
                  return null;
                }
                invoiceAddCost.push({
                  soAddCostID: item.ID,
                  costComponentID: item.costComponentID,
                  itemName: item.itemName,
                  costPrice: item.costPrice,
                  revAccountID: item.revAccountID,
                  accountName: item.accountName,
                  deleteInd: false,
                });
                return item;
              });
              setFieldValue("addCostTotal", document.addCostTotal);
              setFieldValue("invoiceAddCost", invoiceAddCost);
              handleChangeCustomer(document.customerID);
              setOpenSearchDocRef(false);
            } else if (docRef === "2") {
              setFieldValue("docRef", docRef);
              setFieldValue("docRefDesc", "Delivery");
              setFieldValue("salesOrderID", document.salesOrderID);
              setFieldValue("deliveryID", document.ID);
              setFieldValue("customerID", document.customerID);
              setFieldValue("customerName", document.customer.customerName);
              setFieldValue("exchangeRate", document.salesOrder.exchangeRate);
              setFieldValue("invoiceAddCost", []);
              let deliveryItem = [];
              let invoiceAddCost = [];
              getSoDeliveryDetail(document.ID).then((response) => {
                const { data } = response.data;
                const delivery = data.soDelivery;
                let totalPrice = 0;
                let discountAmount = 0;
                let taxAmount = 0;
                let subTotal = 0;
                let grandTotal = 0;
                handleChangeCustomer(delivery.customerID);
                setFieldValue("salesOrderCode", delivery.salesOrderCode);
                delivery.deliveryItem.map((item, index) => {
                  totalPrice = item.salesOrderItem.unitPrice * item.qty;
                  discountAmount = amountByPercent(
                    item.salesOrderItem.discountPercent,
                    totalPrice
                  );
                  totalPrice -= discountAmount;

                  taxAmount = amountByPercent(
                    item.salesOrderItem.taxPercent,
                    totalPrice
                  );
                  totalPrice += taxAmount;

                  deliveryItem.push({
                    ID: 0,
                    salesOrderItemID: item.salesOrderItemID,
                    deliveryItemID: item.ID,
                    itemID: item.itemID,
                    itemType: item.itemType,
                    itemTypeName: item.itemTypeName,
                    itemCode: item.itemCode,
                    itemName: item.itemName,
                    varCode: item.varCode,
                    qty: item.qty,
                    uomID: item.uomID,
                    uomName: item.uomName,
                    unitPrice: item.salesOrderItem.unitPrice,
                    taxPercent: item.salesOrderItem.taxPercent,
                    taxAmount: taxAmount,
                    discountPercent: item.salesOrderItem.discountPercent,
                    discountAmount: discountAmount,
                    totalPrice: totalPrice,
                    expenseAccountID: 0,
                    accountName: "",
                    unRegItem: false,
                    soItem: true,
                    deliveryItem: true,
                    deleteInd: false,
                  });
                  subTotal += totalPrice;
                });
                delivery.deliveryService.map((item, index) => {
                  totalPrice = item.salesOrderItem.unitPrice * item.qty;
                  discountAmount = amountByPercent(
                    item.salesOrderItem.discountPercent,
                    totalPrice
                  );
                  totalPrice -= discountAmount;

                  taxAmount = amountByPercent(
                    item.salesOrderItem.taxPercent,
                    totalPrice
                  );
                  totalPrice += taxAmount;
                  deliveryItem.push({
                    ID: 0,
                    salesOrderItemID: item.salesOrderItemID,
                    deliveryItemID: item.ID,
                    itemID: item.itemID,
                    itemType: item.itemType,
                    itemTypeName: item.itemTypeName,
                    itemCode: item.serviceCode,
                    itemName: item.serviceName,
                    varCode: item.varCode,
                    qty: item.qty,
                    uomID: item.uomID,
                    uomName: item.uomName,
                    unitPrice: item.salesOrderItem.unitPrice,
                    taxPercent: item.salesOrderItem.taxPercent,
                    taxAmount: taxAmount,
                    discountPercent: item.salesOrderItem.discountPercent,
                    discountAmount: discountAmount,
                    totalPrice: totalPrice,
                    expenseAccountID: 0,
                    accountName: "",
                    unRegItem: false,
                    soItem: true,
                    deliveryItem: true,
                    deleteInd: false,
                  });
                  subTotal += totalPrice;
                });

                let addCostTotal = 0;
                data.salesOrderAddCost.map((item, index) => {
                  if (item.invoiceID > 0) {
                    return null;
                  }
                  invoiceAddCost.push({
                    soAddCostID: item.ID,
                    itemName: item.itemName,
                    costPrice: item.costPrice,
                    revAccountID: item.revAccountID,
                    accountName: item.accountName,
                    deleteInd: false,
                  });
                  addCostTotal += item.costPrice;
                  subTotal += item.costPrice;
                  return item;
                });
                grandTotal = subTotal;
                setFieldValue("currencyID", delivery.currencyID);
                setFieldValue("currencyCode", delivery.currencyCode);
                setFieldValue(
                  "unbilledPercent",
                  delivery.salesOrder.unbilledPercent
                );
                setFieldValue(
                  "unbilledAmount",
                  delivery.salesOrder.unbilledAmount
                );
                setFieldValue("invoiceAddCost", invoiceAddCost);
                setFieldValue("invoiceItem", deliveryItem);
                setFieldValue("subTotal", subTotal);
                setFieldValue(
                  "discountPercent",
                  delivery.salesOrder.discountPercent
                );
                discountAmount = amountByPercent(
                  delivery.salesOrder.discountPercent,
                  grandTotal
                );
                setFieldValue("discountAmount", discountAmount);

                grandTotal -= discountAmount;

                setFieldValue("taxPercent", delivery.salesOrder.taxPercent);
                taxAmount = amountByPercent(
                  delivery.salesOrder.taxPercent,
                  grandTotal
                );
                setFieldValue("taxAmount", taxAmount);

                grandTotal += taxAmount;
                grandTotal += delivery.deliveryCost;
                setFieldValue("addCostTotal", addCostTotal);
                setFieldValue("deliveryCost", delivery.deliveryCost);
                setFieldValue("grandTotal", grandTotal);
                setFieldValue("billPercent", 100);
                setFieldValue("billAmount", grandTotal);
              });
              setOpenSearchDocRef(false);
            }
            setFieldValue("address", document.address);
            setFieldValue("city", document.city);
            setFieldValue("province", document.province);
            setFieldValue("countryCode", document.countryCode);
            setFieldValue("postalCode", document.postalCode);
            setFieldValue("addressPhone", document.addressPhone);
            setFieldValue("addressEmail", document.addressEmail);
            setFieldValue("contactName", document.customer.contactName);
            setFieldValue("position", document.customer.position);
            setFieldValue("contactPhone", document.customer.contactPhone);
            setFieldValue("contactEmail", document.customer.contactEmail);
            setCustomerAddressDefault(true);
            setCustomerContactDefault(true);
            setCustomerTOCDefault(true);
          }}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchDocRef(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>

      <DialogLayout
        open={openSearchCashAccount}
        title="Search GL Account"
        onCloseDialog={() => {
          setOpenSearchCashAccount(false);
        }}
        maxWIdth="md"
      >
        <SearchGlAccount
          accountTypeID={1}
          onSelectGlAccount={(glAccount) => {
            setFieldValue("cashAccountID", glAccount.ID);
            setFieldValue("cashAccountName", glAccount.accountName);
            setOpenSearchCashAccount(false);
          }}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchCashAccount(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
    </React.Fragment>
  );

  async function handleChangeCustomer(customerID) {
    const responseAddress = await getCustomerAddress(customerID);
    const { data: dataAddress } = responseAddress.data;
    setCustomerAddresses(dataAddress.addresses);

    const responseContact = await getCustomerContact(customerID);
    const { data: dataContact } = responseContact.data;
    setCustomerContacts(dataContact.contacts);
  }

  async function getInvoiceTOCData(appCode) {
    const response = await getPredefinedTOCs(appCode);
    const { data } = response.data;
    setInvoiceTOCs(data.predefinedTOCs);
  }

  function handleCustomerAddressDefault() {
    setCustomerAddressDefault(false);
  }

  function handleCustomerContactDefault() {
    setCustomerContactDefault(false);
  }

  function handleCustomerTOCDefault() {
    setCustomerTOCDefault(false);
  }
}

export default InvoiceHeader;
